import { useMemo } from 'react';
import { useTranslation } from '@sib/i18n';

export const useBooleanOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t('yes'), value: 'true' },
      { label: t('no'), value: 'false' },
    ],
    [t]
  );
};
